import {
  IImageRulesConfig,
  IRequirementItem,
  REQUIREMENT_DEFINITIONS,
} from '../constants/imageRules';

/**
 * Converts a backend image-rules configuration into UI-friendly requirement
 * items. Only enabled rules are returned; disabled rules are omitted.
 */
export const mapImageRulesToRequirements = (
  config: IImageRulesConfig | null | undefined,
): IRequirementItem[] => {
  if (!config) {
    return [];
  }

  return REQUIREMENT_DEFINITIONS.filter((definition) =>
    definition.isEnabled(config),
  ).map((definition) => ({
    id: definition.id,
    iconId: definition.iconId,
    titleKey: definition.titleKey,
    titleDefault: definition.titleDefault,
    descriptionKey: definition.descriptionKey,
    descriptionDefault: definition.descriptionDefault,
    descriptionValues: definition.getDescriptionValues?.(config),
    backgroundColor: definition.getBackgroundColor?.(config) ?? null,
  }));
};
